import type StudyDocumentModel from '../../../models/StudyDocumentModel';
import { requestAndParse, requestSuccessful } from '../request';

const createParticipantDocument = async (
    name: string,
    file: File,
    participantId: string,
) => {
    const route = 'admin/create-participant-document';
    const payload = { name, file, participantId };

    const response = await requestAndParse(route, payload, 'POST', true);

    const success = requestSuccessful(response);
    const document = response.body?.document as StudyDocumentModel[];

    return { success, document };
};

export default createParticipantDocument;
